import { injectable } from "inversify";
import { TYPE, rootContainer } from "../container/root";
import { IApiResponse, IHttpService } from "../http-service";
import {
    IMigrateGlobalEMerchantsRequestData
} from "../../pages/admins/migrate-global-e-merchants/stores/migrate-global-e-merchants-page-store";

export enum GlobalEEnvironment {
    QA = "QA",
    INT = "INT",
    PROD = "PRODUCTION",
}

export interface IMigrateGlobaleShopifyStoreRequest {
    portal_id: number;
}

export interface IMigrateGlobaleShopifyStoreResponse {
    num_deleted_reasons: number;
    num_deleted_resolutions: number;
    num_deleted_return_methods: number;
}

export interface IGlobaleStoreMetaFields {
    merchant_id: number;
    env: GlobalEEnvironment;
}

export interface IActivateGlobaleMerchantResponse {
    successful_activation: boolean;
}

@injectable()
class AdminMigrateGlobalEMerchantsService {
    private readonly httpService: IHttpService = rootContainer.get<IHttpService>(TYPE.ApiHttp);

    public async migrateGlobalEMerchants(request: IMigrateGlobalEMerchantsRequestData): Promise<void> {
        await this.httpService.post<IApiResponse<void>>(
            "/rms-api/admin-migrate-global-e-merchants",
            {
              ...request
            }
        );
    }

    public async migrateGlobalEShopifyPlatformStore(request: IMigrateGlobaleShopifyStoreRequest): Promise<IMigrateGlobaleShopifyStoreResponse> {
        const res = await this.httpService.post<IApiResponse<IMigrateGlobaleShopifyStoreResponse>>(
            "/rms-api/admin-migrate-shopify-platform-globale-merchants",
            {
              ...request
            }
        );
        return res.payload;
    }
    
    public async fetchGlobaleStoreMetaFields(portalId: number): Promise<IGlobaleStoreMetaFields> {
        const res = await this.httpService.get<IApiResponse<IGlobaleStoreMetaFields>>(
            `/rms-api/admin-migrate-shopify-get-globale-metafields/${portalId}`
        );
        return res.payload;
    }

    public async activateGlobaleMerchant(request: IMigrateGlobaleShopifyStoreRequest): Promise<IActivateGlobaleMerchantResponse> {
        const res = await this.httpService.post<IApiResponse<IActivateGlobaleMerchantResponse>>(
            '/rms-api/admin-activate-globale-merchant',
            request
        );
        return res.payload;
    }
}

export default AdminMigrateGlobalEMerchantsService;
